import React, { useState } from 'react';
import axios from 'axios';
import './admin.css';

const Admin = () => {
  const [house, setHouse] = useState({
    picture: null,
    name:'',
    type: '',
    rent: '',
    location: '',
    ownerNumber: '',
    securityFeatures: '',
  });

  const locations = [
    'Kimbo',
    'K-Road',
    'Juja',
    'Gate A',
    'Gate B',
    'Gate C',
    'Gate D',
    'Gashororo',
    'Oasis',
    'Weiteithie',
    'Gatundu Road',
  ];

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'picture') {
      setHouse((prevState) => ({ ...prevState, [name]: files[0] }));
    } else {
      setHouse((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.entries(house).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      await axios.post(`http://localhost:3002/houses/${house.location}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('House data submitted successfully');

      setHouse({
        picture: null,
        name:'',
        type: '',
        rent: '',
        location: '',
        ownerNumber: '',
        securityFeatures: '',
      });
    } catch (error) {
      console.error('Error submitting house data:', error);
    }
  };

  return (
    <div className='cont'>
      <form className='admin' onSubmit={handleSubmit}>
        <div>
          <label className='pic' htmlFor="picture">Picture:</label>
          <input
            type="file"
            id="picture"
            name="picture"
            onChange={handleChange}
          />
        </div>
        <div>
          <label className='hse' htmlFor="name">House Name:</label>
          <input
            type="name"
            id="name"
            name="name"
            value={house.name}
            onChange={handleChange}
          />
        </div>
        <div>
          <label className='type' htmlFor="type">House Type:</label>
          <input
            type="text"
            id="type"
            name="type"
            value={house.type}
            onChange={handleChange}
          />
        </div>
        <div>
          <label className='rent' htmlFor="rent">Rent Payable:</label>
          <input
            type="text"
            id="rent"
            name="rent"
            value={house.rent}
            onChange={handleChange}
          />
        </div>
        <div>
          <label className='loc' htmlFor="location">Location:</label>
          <select
            id="location"
            name="location"
            value={house.location}
            onChange={handleChange}
          >
            <option value="">Select a location</option>
            {locations.map((location) => (
              <option key={location} value={location}>
                {location}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className='own' htmlFor="ownerNumber">Owner Phone Number:</label>
          <input
            type="text"
            id="ownerNumber"
            name="ownerNumber"
            value={house.ownerNumber}
            onChange={handleChange}
          />
        </div>
        <div>
          <label className='sec' htmlFor="securityFeatures">House Features:</label>
          <input
            type="text"
            id="securityFeatures"
            name="securityFeatures"
            value={house.securityFeatures}
            onChange={handleChange}
          />
        </div>
        <button className='btnn' type="submit">Save</button>
      </form>
    </div>
  );
};

export default Admin;